import React from 'react';
import Navbar from "../../components/Navbar";
import {Button} from "../../components/common";
import {useNavigate} from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="relative px-5 bg-404BG py-12 min-h-screen">
      <Navbar />

      <div className="absolute left-1/2 top-1/2 translate-y-[-50%] translate-x-[-50%] text-center flex items-center flex-col">
        <p className="text-mainBlack text-[180px] leading-[180px] mb-4">404</p>
        <span className="font-bold text-mainBlack text-[24px] leading-[29px] mb-4">Страница не найдена</span>
        <Button title="Вернуться на главную" onClick={() => navigate('/')} />
      </div>
    </div>
  )
};

export default NotFound;
